(function(){
  const searchInput = document.getElementById('blogSearch');
  const blogGrid   = document.getElementById('blogGrid');
  const cards      = document.querySelectorAll('.blog-card');
  const loadBtn    = document.getElementById('loadMore');
  let visible      = 9;

  // Initial hide
  cards.forEach((c,i)=>{ if(i >= visible) c.style.display='none'; });

  // Load More
  loadBtn.addEventListener('click', () => {
    visible += 6;
    cards.forEach((c,i)=>{ if(i < visible) c.style.display=''; });
    if (visible >= cards.length) loadBtn.style.display='none';
  });

  // Search filter
  searchInput.addEventListener('keyup', () => {
    const filter = searchInput.value.toLowerCase();
    cards.forEach(card => {
      const title = card.querySelector('h3').textContent.toLowerCase();
      card.style.display = title.includes(filter) ? '' : 'none';
    });
  });
})();